import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import {Doughnut} from "react-chartjs-2";

export function InvoiceStages(props) {

const data = useSelector(state => state.dashboard.dashboard.invoice_summary);

// create ordered data paired with colors based on redux store
const pieData = {
    draft: [
        {'Draft': data['Draft'], color: '#efefef'}
    ],
    ongoing: [
        {'Rejected': data['Rejected'], color: '#f7d4cd'},
        {'Adjudication Initiated': data['Adjudication Initiated'], color: '#f38e73'},
        {'Review': data['Review'], color: '#5c6cff'},
        // {'Revision Draft': data['Revision Draft'], color: '#d9d9d9'},
        {'Payment Required': data['Payment Required'], color: '#d0efc5'},
        {'Paid Unconfirmed': data['Paid Unconfirmed'], color: '#61a948'},
    ],
    completed: [
        {'Paid Confirmed': data['Paid Confirmed'], color: '#247607'},
        // {'Cancelled': data['Cancelled'], color: '#fae1a5'},
        {'Adjudication Complete': data['Adjudication Complete'], color: '#f4c143'},
    ]
};

const [pieDataShown, setPieDataShown] = useState(null);
const [showDraft, setShowDraft] = useState(true);
const [showOngoing, setShowOngoing] = useState(true);
const [showComleted, setShowCompleted] = useState(true);

useEffect(() => {
    // on mount, set pieDataShown to show all data
    setPieDataShown(pieData.draft.concat(pieData.ongoing, pieData.completed));
}, [])

useEffect(() => {
    // when visibility of a certain status is changed, update the PieDataShown
    let draftData = showDraft ? pieData.draft : [];
    let ongoingData = showOngoing ? pieData.ongoing : [];
    let completedData = showComleted ? pieData.completed : [];
    setPieDataShown(draftData.concat(ongoingData, completedData));
}, [showComleted, showDraft, showOngoing]);

// create distinct arrays from filtered data to feed chart
const labels = pieDataShown ? pieDataShown.map((item) => Object.keys(item)[0]) : null;
const counts = pieDataShown ? pieDataShown.map((item) => item[Object.keys(item)[0]]) : null;
const colors = pieDataShown ? pieDataShown.map((item) => item.color) : null;

    return (
        <div className="w charts-wrapper pie gap-below-s">
            <h3 className="title2 gap-below-m">Invoice Stage Distribution</h3>
            <div className="checkbox-wrapper iblock" >
                <input 
                    className="typical-checkbox"
                    type="checkbox"
                    id="show_draft"
                    name="show_draft"
                    checked={showDraft}
                    onChange={() => setShowDraft(!showDraft)}
                />
                <label htmlFor="show_draft" className="content2 light-black multiline" >Drafts</label>
            </div>
            <div className="checkbox-wrapper iblock" >
                <input 
                    className="typical-checkbox"
                    type="checkbox"
                    id="show_ongoing"
                    name="show_ongoing"
                    checked={showOngoing}
                    onChange={() => setShowOngoing(!showOngoing)}
                />
                <label htmlFor="show_ongoing" className="content2 light-black multiline" >Ongoing</label>
            </div>
            <div className="checkbox-wrapper iblock" >
                <input 
                    className="typical-checkbox"
                    type="checkbox"
                    id="show_completed"
                    name="show_completed"
                    checked={showComleted}
                    onChange={() => setShowCompleted(!showComleted)}
                />
                <label htmlFor="show_completed" className="content2 light-black multiline" >Closed</label>
            </div>
            <div className="chart-wrapper doughnut" >

                {pieDataShown &&
                    <Doughnut 
                        data={{
                            labels: labels,
                            className: 'testing',
                            datasets: [
                                {
                                data: counts,
                                backgroundColor: colors,
                                borderColor: "white",
                                borderWidth: 2,
                                },
                            ],
                        }}
                        // height={400}
                        // width={600}
                        options={{
                            cutout: 20,
                            maintainAspectRatio: false,
                            cutoutPercentage: 30,
                            legend: {
                                position: "left",
                                align: "start", 
                                boxWidth: 16,
                                labels: {
                                    usePointStyle: true,
                                    fontSize: 14,
                                    fontStyle: "normal",
                                    boxWidth: 12,
                                    fontColor: "#3C3B41",
                                    padding: 12,
                                },
                            }
                        }}
                    />
                }
            </div>
        </div>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(InvoiceStages);